import styled from "styled-components"

export const Container = styled.div`
    margin: 0.5rem 0.5rem;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 0.5rem;

    @media (max-width: 1130px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
    }
`

export const Card = styled.div`
    background: ${props => props.background}; 
    color: ${props => props.color ? props.color : "#FFF"};
    border-radius: 0.25rem;
    padding: 1rem;
    font-size: 1.5rem;
    font-weight: bold;
    min-height: 10rem;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 2rem;

    strong{
        font-size: 1.8rem;
        display: flex;
        align-items: center;
        gap: 1rem;

        svg{
            font-size: 1.6rem;
        }
    }
`